module.exports = __webpack_public_path__ + "img/full-jobbatical-1.b2859c09.jpg";